/* @flow */
import './App.scss'
import React from 'react'
import Helmet from 'react-helmet'
import favicon from '../../common/app/favicon'
import start from '../../common/app/start'
import { Route } from 'react-router'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { toggleNavigation, setScrollLocation } from '../../common/app/actions'
import { setCurrentLocale } from '../../common/intl/actions'
import debounce from 'debounce'

import Header from './Header'
import CookiesInfo from './CookiesInfo'
import Footer from './Footer'
import { SwitchWithRoutes } from '../components/routing'

// routes
import routes, { MatchWithSubRoutes } from './routes'
import NotFound from '../NotFound/NotFoundPage'

const metas = [
  { charset: 'utf-8' },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
  },
  {
    'http-equiv': 'x-ua-compatible',
    content: 'ie=edge',
  },
]

export const messages = defineMessages({
  linkHowItWorksUrl: {
    id: 'app.links.howItWorks.url',
    defaultMessage: 'jak-to-funguje',
  },
  linkHowItWorksText: {
    id: 'app.links.howItWorks.text',
    defaultMessage: 'Jak to funguje',
  },
  linkFeaturesUrl: {
    id: 'app.links.features.url',
    defaultMessage: 'vyhody',
  },
  linkFeaturesText: {
    id: 'app.links.features.text',
    defaultMessage: 'Výhody',
  },
  linkContactUrl: {
    id: 'app.links.contact.url',
    defaultMessage: 'kontakt',
  },
  linkContactText: {
    id: 'app.links.contact.text',
    defaultMessage: 'Kontakt',
  },
  linkInquiryUrl: {
    id: 'app.links.inquiry.url',
    defaultMessage: 'kontakt',
  },
  linkInquiryText: {
    id: 'app.links.inquiry.text',
    defaultMessage: 'Nezávazná poptávka',
  },
  pageTitle: {
    id: 'app.title',
    defaultMessage: 'Stadyum CRM | Chytré systémy pro fotbalové kluby',
  },
  metaDescription: {
    id: 'app.metas.description',
    defaultMessage: 'Chytré systémy pro fotbalové kluby',
  },
  metaTitle: {
    id: 'app.metas.title',
    defaultMessage: 'STADYUM.CZ | Intelligent systems for footbal club management',
  },
  metaImage: {
    id: 'app.metas.image',
    defaultMessage: 'http://stadyum.cz/images/stadyum-fb.jpg',
  },
  metaSiteName: {
    id: 'app.metas.siteName',
    defaultMessage: 'STADYUM.CZ',
  },
})

const links = (intl) => [
  {
    url: `#${intl.formatMessage(messages.linkHowItWorksUrl)}`,
    text: intl.formatMessage(messages.linkHowItWorksText),
  },
  {
    url: `#${intl.formatMessage(messages.linkFeaturesUrl)}`,
    text: intl.formatMessage(messages.linkFeaturesText),
  },
  {
    url: `#${intl.formatMessage(messages.linkContactUrl)}`,
    text: intl.formatMessage(messages.linkContactText),
  },
  {
    url: `#${intl.formatMessage(messages.linkInquiryUrl)}`,
    text: intl.formatMessage(messages.linkInquiryText),
    callout: true,
  },
]

const getLocale = (pathname) => (pathname && pathname.substr(1)) || 'cs'

const getScrollTop = () => {
  if (typeof pageYOffset !== 'undefined') {
    // most browsers except IE before #9
    return pageYOffset
  }
  const B = document.body // IE 'quirks'
  let D = document.documentElement // IE with doctype
  D = (D.clientHeight) ? D : B
  return D.scrollTop
}

//eslint-disable-next-line
class App extends React.Component {
  constructor() {
    super()
    this.handleScroll = debounce(() => this._handleScroll(), 10)
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps(newProps) {
    const { setCurrentLocale, pathname, locales } = this.props
    const newPathname = newProps.pathname
    const oldLocale = getLocale(pathname)
    const newLocale = getLocale(newPathname)
    if (oldLocale !== newLocale && locales.includes(newLocale)) {
      setCurrentLocale(newLocale)
    }
  }

  componentWillUnmount() {
    document.documentElement.removeEventListener('scroll', this.handleScroll)
  }

  _handleScroll() {
    const { setScrollLocation } = this.props
    setScrollLocation(getScrollTop())
  }

  render() {
    const {
      currentLocale,
      errors,
      navigationVisible,
      navigationOverlayVisible,
      toggleNavigation,
      intl,
      locales,
      pathname,
    } = this.props
    let notFound = errors.filter(e => e.code === 404).size > 0
    if (!locales.includes(getLocale(pathname))) notFound = true
    return (
      <div className="app-container">
        <Helmet
          htmlAttributes={{ lang: currentLocale }}
          titleTemplate={intl.formatMessage(messages.pageTitle)}
          meta={[
            ...metas,
            {
              name: 'description',
              content: intl.formatMessage(messages.metaDescription),
            },
            {
              property: 'og:title',
              content: intl.formatMessage(messages.metaTitle),
            },
            {
              property: 'og:image',
              content: intl.formatMessage(messages.metaImage),
            },
            {
              property: 'og:site_name',
              content: intl.formatMessage(messages.metaSiteName),
            },
            {
              property: 'og:description',
              content: intl.formatMessage(messages.metaDescription),
            },
            ...favicon.meta,
          ]}
          link={[
            ...favicon.link,
          ]}
        />

        {!notFound &&
          <Header
            toggle={toggleNavigation}
            visible={navigationVisible}
            scrolled={navigationOverlayVisible}
            links={links(intl)}
            currentLocale={currentLocale}
          />
        }

        {/* {notFound ? '' : routes.map((route, i) => (
          <MatchWithSubRoutes key={i} {...route} />
        ))} */}

        <SwitchWithRoutes routes={routes} notFound resourceNotFound={notFound} />


        {/* <Route component={NotFound} /> */}
        <CookiesInfo />
        <Footer />
      </div>
    )
  }
}

App.propTypes = {
  currentLocale: React.PropTypes.string.isRequired,
  errors: React.PropTypes.object.isRequired,
  navigationVisible: React.PropTypes.bool.isRequired,
  toggleNavigation: React.PropTypes.func.isRequired,
  setScrollLocation: React.PropTypes.func.isRequired,
  pathname: React.PropTypes.string.isRequired,
  locales: React.PropTypes.array.isRequired,
  navigationOverlayVisible: React.PropTypes.bool.isRequired,
  intl: React.PropTypes.object.isRequired,
  setCurrentLocale: React.PropTypes.func.isRequired,
}

App = connect(state => ({
  currentLocale: state.intl.currentLocale,
  locales: state.intl.locales,
  errors: state.app.errors,
  navigationVisible: state.app.navigationVisible,
  navigationOverlayVisible: state.app.navigationOverlayVisible,
  pathname: (state.app.location && state.app.location.pathname) || '',
}), { toggleNavigation, setScrollLocation, setCurrentLocale })(App)

App = start(injectIntl(App))

export default App



// WEBPACK FOOTER //
// ./src/browser/app/App.js